import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCooler = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 85,
	height: 90,
	viewBox: "0 0 85.0 90.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 40,
		cy: 45,
		rx: 40,
		ry: 40,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 0.0 L 10.0 90.0 M 85.0 15.0 L 50.0 15.0 L 50.0 35.0 L 65.0 35.0 L 65.0 60.0 L 50.0 60.0 L 50.0 80.0 L 85.0 80.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgCooler;
